export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_PRODUCTS_CAN_ACCESS = 'SET_PRODUCTS_CAN_ACCESS';
export const SET_PRODUCTS_CAN_ACCESS_HASH = 'SET_PRODUCTS_CAN_ACCESS_HASH';
export const RESET = 'RESET';
export const RESET_CRT_PRODUCT = 'RESET_CRT_PRODUCT';
export const SET_CRT_PRODUCT = 'SET_CRT_PRODUCT';
export const SET_USER_PRODUCT_PERMISSION = 'SET_USER_PRODUCT_PERMISSION';
export const SET_SESSION_ID = 'SET_SESSION_ID';
export const SET_IS_NEED_SECOND_AUTH = 'SET_IS_NEED_SECOND_AUTH';

export const SET_PLUGINS_API_BASE_URL = 'SET_PLUGINS_API_BASE_URL';
export const SET_PLUGINS_PERMISSIONS = 'SET_PLUGINS_PERMISSIONS';

export const SET_WS_EXPORT_NUMBER = 'SET_WS_EXPORT_NUMBER';

export const SET_WS_EXPORT_INFO= 'SET_WS_EXPORT_INFO';
